import { Flex, Grid, Loader } from "@aws-amplify/ui-react";
import {
  CCard,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { API, graphqlOperation, Storage } from "aws-amplify";
import { useEffect, useState } from "react";
import LocalizedStrings from "react-localization";

import { getUser } from "graphql/queries";
import ActionIcon from "components/actions/ActionIcon";
import DefaultPhoto from "static/images/DefaultPhoto.png";
import SelectUser from "components/users/SelectUser";

const TechnicianCard = ({ technicianID, selectTechnician }) => {
  const [technicianState, setTechnicianState] = useState({});
  const [loading, setLoading] = useState(false);
  const [openSelectTechnician, setOpenSelectTechnician] = useState(false);

  const onSelectUser = (id) => {
    selectTechnician(id);
    setOpenSelectTechnician(false);
  };

  async function fetchUser(id) {
    try {
      setLoading(true);
      const userData = await API.graphql(
        graphqlOperation(getUser, {
          id,
        })
      );
      const userItem = userData.data.getUser;
      if (userItem.photoSrc) {
        userItem.photoSrc = await Storage.get(
          `profile-photos/${userItem.photoSrc}`,
          {
            level: "public",
          }
        );
      }
      setTechnicianState(userItem);
    } catch (err) {
      console.log("Error fetchUser", err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (technicianID) fetchUser(technicianID);
    else setTechnicianState({});
  }, [technicianID]);

  return (
    <>
      <CCard
        className="p-3"
        borderRadius="medium"
        variation="outlined"
        style={{ height: "100%" }}
      >
        {loading ? (
          <Loader />
        ) : (
          <Flex gap="5px" justifyContent="space-between" wrap="wrap">
            <Grid gap="5px" justifyContent="center">
              <img
                src={technicianState?.photoSrc || DefaultPhoto}
                alt="photo_profile"
                className="rounded"
                style={{ maxWidth: "80px", maxHeight: "80px" }}
              />
              <Flex justifyContent="center" gap="0px">
                <ActionIcon
                  name={strings.editTechnician}
                  icon="Edit"
                  color="primary"
                  onClick={() => setOpenSelectTechnician(true)}
                />
                {technicianState?.email && (
                  <ActionIcon
                    name={strings.deleteTechnician}
                    icon="Delete"
                    color="red.60"
                    onClick={() => selectTechnician(null)}
                  />
                )}
              </Flex>
            </Grid>
            <Grid gap="5px" textAlign="center" alignContent="center">
              {!technicianState?.email && strings.noTechnician}
              {technicianState?.email && (
                <>
                  <b>{strings.technician}</b>
                  <span>{technicianState?.name}</span>
                  <span>{technicianState?.email}</span>
                  <span>{technicianState?.position}</span>
                </>
              )}
            </Grid>
          </Flex>
        )}
      </CCard>
      {openSelectTechnician && (
        <CModal
          portal={false}
          alignment="center"
          visible={openSelectTechnician}
          backdrop="static"
          onClose={() => setOpenSelectTechnician(false)}
        >
          <CModalHeader>
            <CModalTitle>{strings.selectTechnician}</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <SelectUser onSelect={onSelectUser} />
          </CModalBody>
        </CModal>
      )}
    </>
  );
};

const strings = new LocalizedStrings({
  es: {
    technician: "Técnico",
    editTechnician: "Editar Técnico",
    selectTechnician: "Seleccionar Técnico",
    deleteTechnician: "Eliminar Técnico",
    noTechnician: "No se ha seleccionado un técnico",
  },
});

export default TechnicianCard;
